import React from 'react';
import Lock from '@uber/base-icons/lock';
import { styled, useStyletron } from 'baseui';
import { PLACEMENT as TOOLTIP_PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { LabelSmall } from 'baseui/typography';
import type { AnnotationInfoT } from '../annotations/types';
import { statefulTooltipSidePanelOverrides, TooltipContentLabel } from './common/tooltip';
import { ICON_SIZE } from './constants';
type PropsT = {
  annotation: AnnotationInfoT;
  icon: React.ReactNode;
};
const Container = styled<'div', {
  isVisible: boolean;
}>('div', ({
  $theme,
  isVisible
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale200,
  opacity: isVisible ? 1 : 0.5,
  flexBasis: '60%'
}));
const IconContainer = styled('span', {
  flexBasis: '10%',
  justifyContent: 'flex-start',
  display: 'flex'
});
const NameContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale400
}));
const NameLabel = styled(LabelSmall, ({
  $theme
}) => ({
  margin: 0,
  paddingRight: $theme.sizing.scale200,
  '::first-letter': {
    textTransform: 'capitalize'
  },
  wordBreak: 'break-all'
}));
export function AnnotationContent({
  annotation,
  icon
}: PropsT) {
  const [, theme] = useStyletron();
  const {
    isVisible,
    name,
    isLocked
  } = annotation;
  return <Container isVisible={isVisible}>
      <IconContainer>{icon}</IconContainer>
      <NameContainer>
        <NameLabel>{name}</NameLabel>
        {isLocked && <StatefulTooltip placement={TOOLTIP_PLACEMENT.bottomLeft} overrides={statefulTooltipSidePanelOverrides} content={() => <TooltipContentLabel>
                Annotation is locked. You cannot edit or delete it.
              </TooltipContentLabel>} showArrow>
            <div>
              <Lock size={ICON_SIZE} color={theme.colors.contentPrimary} />
            </div>
          </StatefulTooltip>}
      </NameContainer>
    </Container>;
}